import { useEffect, useCallback, RefObject } from 'react';

export default function useOutsideClick(
  refs: Array<
    RefObject<
      | null
      | HTMLButtonElement
      | HTMLDivElement
      | HTMLInputElement
      | HTMLLabelElement
      | HTMLParagraphElement
      | HTMLSpanElement
    >
  >,
  handler: (isInside: boolean) => void,
  options: {
    events: (keyof DocumentEventMap)[];
  } = { events: ['mouseup', 'touchstart'] }
) {
  const handleClickOutside = useCallback(
    (e: MouseEvent | TouchEvent) => {
      const isInside = refs.some(
        (r) => r?.current && r.current.contains(e.target as Element)
      );
      handler(isInside);
    },
    [handler, refs]
  );

  useEffect(() => {
    options?.events.forEach((evt) => {
      document.addEventListener(evt, handleClickOutside);
    });

    return () => {
      options?.events.forEach((evt) => {
        document.removeEventListener(evt, handleClickOutside);
      });
    };
  }, [refs, handler, handleClickOutside, options?.events]);
}
